import { getWindowData } from "owa-window-data";

export function isHosted(): boolean {
    // metaos and opx are both hosted experiences
    return (getWindowData()?.location?.pathname.indexOf("/hosted") == 0 ||
        getWindowData()?.location?.pathname.indexOf("/opx") == 0);
}
